// src/components/products/ForWomenCategoriesClone.jsx
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get_for_women_categories } from '../../store/reducers/forwomenCategoriesReducer'
import { Link } from 'react-router-dom'

const ForWomenCategoriesClone = () => {
    const dispatch = useDispatch()
    const { items, loading, error } = useSelector(s => s.forWomenCategories)

    useEffect(() => {
        dispatch(get_for_women_categories())
    }, [dispatch])

    if (loading) return <div className="py-8 text-center">Loading…</div>
    if (error) return <div className="py-8 text-center text-red-500">Error: {error}</div>

    return (
        <div className="w-full">
            {/* Section Header */}
            <div className="mb-3">
                <h2 className="text-xl font-semibold text-gray-900">For Women</h2>
                <div className="w-12 h-[2px] bg-gray-300 mt-1 rounded" />
            </div>

            <div className="flex gap-3 overflow-x-auto hide-scrollbar pb-4">
                {items.map(cat => (
                    <Link
                        key={cat._id}
                        to={`/shop?forCategory=For%20Women&category=${encodeURIComponent(cat.name)}`}
                        className="relative min-w-[120px] h-[150px] flex-shrink-0 bg-white rounded-md shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden"
                    >
                        <img
                            src={cat.image}
                            alt={cat.name}
                            className="w-full h-full object-cover"
                        />
                        <div
                            className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/50 to-transparent px-4 py-1"
                        >
                            <span className="inline-flex items-center text-white text-lg font-medium">
                                {/* little white bar */}
                                <span className="inline-block w-0.5 h-6 bg-white mr-2 rounded-sm" />
                                {cat.name}
                            </span>
                        </div>

                    </Link>
                ))}
            </div>
        </div>
    )
}

export default ForWomenCategoriesClone
